/**
 * TargetEnvironment is used to inform how we should bundle the package.
 * For node or worker targets, we can't use library mode. We also will adjust
 * conditions we resolve in the exports map.
 *
 * WARNING: `'node'` environment is a work in progress and may not be fully supported.
 */
export type TargetEnvironment = 'node' | 'browser';
